import { Jackpot, createUnblockJackpotMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockJackpotModel = ConfirmModalModel<Jackpot, number, Jackpot>;

export const createUnblockJackpotModel = (): UnblockJackpotModel => {
	const unblockJackpotMutation = createUnblockJackpotMutation();

	const model = createConfirmModalModel<Jackpot, number, Jackpot>({
		modalData: declareModalData<Jackpot>(),
		mapModalData: ({ id }) => id,
		mutation: unblockJackpotMutation,
		successMessageKey: 'unblock-jackpot.success',
	});

	return model;
};
